// Seeded shuffles: quizzes use repeatable seeds; matching uses a fresh visit seed.
// Legacy quizzes reshuffle the choices after every wrong answer; each round here
// produces a different order from the one before.

function hash(text: string): number {
    let value = 2166136261;
    for (let index = 0; index < text.length; index++) {
        value ^= text.charCodeAt(index);
        value = Math.imul(value, 16777619);
    }
    return value >>> 0;
}

function random(seed: number): () => number {
    let state = seed;
    return () => {
        state = (state + 0x6D2B79F5) | 0;
        let t = Math.imul(state ^ (state >>> 15), 1 | state);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

export function shuffledOrder(length: number, seed: string, round: number, previous?: number[]): number[] {
    const next = random(hash(`${seed}:${round}`));
    const order = Array.from({ length }, (_, index) => index);
    for (let index = length - 1; index > 0; index--) {
        const swap = Math.floor(next() * (index + 1));
        [order[index], order[swap]] = [order[swap], order[index]];
    }
    if (previous && length > 1 && order.every((value, index) => value === previous[index])) {
        order.push(order.shift() as number);
    }
    return order;
}

// Shuffle independently. Same-row matches must remain possible: excluding them
// reveals the answer on two-pair boards and narrows larger boards predictably.
export function matchingOrders(length: number, seed: string): { left: number[]; right: number[] } {
    const left = shuffledOrder(length, `${seed}-left`, 0);
    const right = shuffledOrder(length, `${seed}-right`, 0);
    return { left, right };
}
